import {ActionList} from '@primer/react'
import {useDiffViewSettings} from '../../contexts/DiffViewSettingsContext'

export function DiffWhitespaceToggle() {
  const {hideWhitespace, updateHideWhitespace} = useDiffViewSettings()

  return (
    <ActionList.Group selectionVariant="single" title="Whitespace" variant="subtle">
      <ActionList.Item selected={hideWhitespace} onSelect={() => updateHideWhitespace(!hideWhitespace)}>
        Hide whitespace
      </ActionList.Item>
    </ActionList.Group>
  )
}

try{ DiffWhitespaceToggle.displayName ||= 'DiffWhitespaceToggle' } catch {}